import { z } from 'zod';

export type Role = 'admin' | 'facilitator' | 'customer' | 'viewer';

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  tenantId: string;
  roles: Role[];
}

// ── Azure Marketplace entitlement (GET /sso-api/marketplace/access) ──────────

export const InternalPlanSchema = z.enum(['FOUNDATION', 'PROFESSIONAL', 'ENTERPRISE']);
export type InternalPlan = z.infer<typeof InternalPlanSchema>;

export const MarketplaceAccessSchema = z.object({
  internalPlan: InternalPlanSchema,
  licensedQuantity: z.number().int().nonnegative(),
  // Kept as plain strings so a new backend key never fails validation; the
  // frontend only gates on the keys in `FeatureKey`.
  enabledFeatures: z.array(z.string()),
});
export type MarketplaceAccess = z.infer<typeof MarketplaceAccessSchema>;

/**
 * Feature keys known to the UI (docs/API_Docs/MARKETPLACE_INTEGRATION.md).
 * The live backend currently returns dashboard, graph, inventory, scoring for
 * ENTERPRISE; the rest are the backend's proposed plan matrix and are NOT yet
 * used to gate navigation — tag a nav entry only once the backend returns the
 * key, or paying users lose the module.
 */
export const FEATURE_KEYS = [
  'dashboard',
  'graph',
  'inventory',
  'scoring',
  'decommission',
  'carbon',
  'vulnerability',
  'threatIntel',
  'aiSoc',
] as const;
export type FeatureKey = (typeof FEATURE_KEYS)[number];
